module.exports = {
  INTERNAL_API_URL: 'http://localhost:8080/internal-api',
  MAX_WITNESSES: 4,
  NOMINATIM_API_URL: 'https://nominatim.openstreetmap.org',
  NOMINATIM_API_REVERSE_GEOCODING_ENDPOINT: '/reverse',
  CHATBOT_URL: 'https://izzyconstat.fr/chatbot',
};
